<div class="reading-background" [ngStyle]="getDeviceHeight()" [ngClass]="{'book-intro-background': isBookIntroVisible}">

    <step-view direction="horizontal" *ngIf="!isWordWallActiveClass && !isBookIntroVisible && !isPipeline"></step-view>

    <div class="container-fluid reading-view-container">
        <div class="row">
            <div id="content-wrapper" class="col-xs-12 col-lg-8 col-xl-8 reading-view"
                 *ngIf="!isWordWallActiveClass && !isBookIntroVisible"
                 [ngStyle]="initReadingViewHeight()"
                 (window:resize)="initReadingViewHeight()"
                 [ngClass]="{'recording': isUIActive, 'scrolling-disabled': isScrollingDisabled()}">
                <content-view #contentView class="content-view"
                              (taiSelected)="taiSelected($event)"
                              (scrollArrowClicked)="scrollAfterRecordArrowClick()"
                              [scrollArrowVisible]="getScrollArrowVisibility()">
                </content-view>

                <progression></progression>
            </div>
            <div id="wordwall-wrapper" class="col-xs-12 col-lg-8 col-xl-8 wordwall-view" *ngIf="isWordWallActiveClass"
                 [ngStyle]="initReadingViewHeight()"
                 (window:resize)="initReadingViewHeight()">
                <wordwall-view [content]="_selection"></wordwall-view>

            </div>

            <div id="book-intro-wrapper" class="reading-view book-intro-wrapper col-xs-12 col-lg-8 col-xl-8" *ngIf="isBookIntroVisible"
                 [ngStyle]="initReadingViewHeight()"
                 (window:resize)="initReadingViewHeight()" [ngClass]="{'book-intro-reading-view': isBookIntroVisible}">
                <book-intro-view [content]="_selection"></book-intro-view>
            </div>

            <div class="col-xs-12 col-lg-4 col-xl-4 side-panel-view">

                <step-view [isShowTai]="showTai" direction="vertical" *ngIf="!isWordWallActiveClass && !isBookIntroVisible && !isPipeline"></step-view>

                <div class="countdown-container col-xs-12" *ngIf="showCountdown">
                    <countdown
                            [run]="showCountdown"
                            (onFinished)="closeCountdown()"
                            class="countdown-row">
                    </countdown>
                </div>

                <glossary [ngClass]="{'hide': !glossaryService.isGlossaryOpened()}"
                          class="col-xs-12 glossary-container"
                          (closeGlossaryEvent)="closeGlossary()">
                </glossary>

                <div class="question-wrapper"  *ngIf="showTai">
                    <question id="questionContainer" class="question-container" [questionEntry]="currentTaiQuestion"
                        (autoClose)="closeTai()" (userClose)="closeTai()">
                    </question>
                </div>


                <quiz class="col-xs-12 quiz-wrapper" *ngIf="isQuizActiveClass"></quiz>

                <word-color class="col-xs-12" *ngIf="isWordColorLegendVisible()"></word-color>

                <div *ngIf="isPipeline" class="pipelineTabContainer">
                    <pipeline></pipeline>
                </div>

            </div>

        </div>
    </div>

    <div class="recording-mask" *ngIf="isRecording() || showCountdown"></div>

    <div class="book-intro-mask" *ngIf="isBookIntroVisible"></div>
</div>

<runtimetest-modal></runtimetest-modal>
<debug-modal></debug-modal>
